import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import * as Sentry from '@sentry/react';
import i18n from '../i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: { componentStack: errorInfo?.componentStack } });
    console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const t = (key, fallback) => i18n.t(key, { defaultValue: fallback });

    return (
      <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
        <ExclamationCircleIcon className="w-12 h-12 text-red-500 mb-4" />
        <h1 className="text-lg font-semibold text-gray-900 mb-2">
          {t('errors.boundary.title', 'Something went wrong')}
        </h1>
        <p className="text-sm text-gray-600 mb-6 max-w-md mx-auto">
          {t('errors.boundary.message', 'An unexpected error occurred. You can try reloading the page.')}
        </p>
        <button
          onClick={this.handleReload}
          className="px-6 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
        >
          {t('errors.boundary.reload', 'Reload page')}
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
